import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocTopic = async ({ docId, topicId }) => {
  let url = `/Docs/${docId}/topic_id`;

  if (topicId) {
    url += `?topicId=${topicId}`;
  }

  return await request.put(
    url,
    null,
    'При изменении темы документа произошла ошибка',
    'Error'
  );
};

const useChangeDocTopicId = () => {
  const mutation = useMutation(changeDocTopic, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocTopicId: mutation.isLoading,
    changeDocTopicId: mutation.mutateAsync,
  };
};

export default useChangeDocTopicId;
